export default __webpack_public_path__ + "static/media/logo muni.cd2abf1d.svg";